import type { CancellationReasonFlowContext } from '../types/machine';
import { useFlowHooks } from '../utils/FlowProvider';

/**
 * The reason the visitor chose in the cancellation reason step, its label and the visitor's own explanation, with the
 * cancellation intake that step fetched: what the step keeps in the flow's context.
 */
export const useChosenCancellationReason = () => {
  const { useFlowSelector } = useFlowHooks<CancellationReasonFlowContext>();
  const reason = useFlowSelector(state => state.context.reason);
  const reasonLabel = useFlowSelector(state => state.context.reasonLabel);
  const explanation = useFlowSelector(state => state.context.explanation);
  const intake = useFlowSelector(state => state.context.intake);

  return { reason, reasonLabel, explanation, intake };
};
